import { CalendarEventModel } from '.'
import { isBoolean, isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'
import { TutorSubjectModel } from '~/model/Tutor'

export default class CalendarSlot extends BaseModel {
  id: string = ''
  start: string = ''
  end: string = ''
  startDate: string = ''
  isPublic: boolean = false
  attachments: Record<string, Array<TutorSubjectModel>> = {}
  events: Array<CalendarEventModel> = []

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['is_public', 'attachments', 'events'])

      if (isBoolean(data.is_public)) {
        this.isPublic = data.is_public
      }

      if (isUnknownObject(data.attachments)) {
        const attachments = data.attachments
        Object.keys(attachments).forEach(collection => {
          const value = attachments[collection]
          if (Array.isArray(value) && value.length) {
            this.attachments[collection] = value.map(v => new TutorSubjectModel(v))
          }
        })
      }

      if (Array.isArray(data.events) && data.events.length) {
        this.events = data.events.map(i => new CalendarEventModel(i))
      }
    }
  }
}
